import Icon from '../Icon/Icon';
import useStyles from './styles';

function Image({ src, alt, className }: ImageProps) {
  const classes = useStyles();

  return src ? (
    <img src={src} alt={alt} className={className} data-testid="image" />
  ) : (
    <div className={`${classes.fallbackImageContainer} ${className}`}>
      <Icon name="camera" className={classes.fallbackImage} data-testid="fallbackImage" />
    </div>
  );
}

export default Image;
